import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "formik";
import { Grid } from "@material-ui/core";
import { TextInput } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelDoubleTextInput = ({ label, fieldName, placeholder, formik, isDisabled, hasBorder, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }
  const val = _.get(formik.values, fieldName);
  const refVal = _.get(formik.values, `${fieldName}Ref`);

  return (
    <LateralField label={label} hasBorder={hasBorder}>
      {isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={10}>
            <ViewOnlyDiv>{val}</ViewOnlyDiv>
          </Grid>
          <Grid item xs={2}>
            <ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>
          </Grid>
        </Grid>)}
      {!isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={9}>
            <TextInput
              fullWidth
              fieldName={fieldName}
              placeholder={placeholder}
              {...otherProps}
            />
          </Grid>
          <Grid item xs={3}>
            <TextInput
              fullWidth
              fieldName={`${fieldName}Ref`}
              placeholder="Add a reference"
              {...otherProps}
            />
          </Grid>
        </Grid>)}
    </LateralField>
  );
};
export default connect(SideLabelDoubleTextInput);
